import { TLocale } from './i18n/Locale';
import { MachineAttribute } from './MachineAttribute';

const units: Partial<
    Record<MachineAttribute, string | Record<TLocale, string>>
> = {
    [MachineAttribute.PRICE_NET_EUR]: '€',
    [MachineAttribute.ENGINE_HOURS]: 'h',
    [MachineAttribute.MAX_SPEED]: 'km/h',
    [MachineAttribute.ENGINE_HP]: {
        en: 'hp',
        de: 'PS',
        fr: 'ch',
        el: 'hp',
        it: 'CV',
        pl: 'KM',
        ro: 'CP',
        ru: 'ls',
        hu: 'LE',
        es: 'CV',
        bg: 'ks',
        sl: 'KM',
        sr: 'KS',
        da: 'hk',
        cs: 'k',
        lt: 'AG',
    },
    [MachineAttribute.ENGINE_KW]: 'kW',
    [MachineAttribute.BALES_TOTAL_NUMBER]: '',
    [MachineAttribute.DRUM_HOURS]: 'h',
    [MachineAttribute.PICKUP_WIDTH]: 'cm',
    [MachineAttribute.WHEEL_FRONT_LEFT_DEPTH]: '%',
    [MachineAttribute.WHEEL_FRONT_RIGHT_DEPTH]: '%',
    [MachineAttribute.WHEEL_REAR_LEFT_DEPTH]: '%',
    [MachineAttribute.WHEEL_REAR_RIGHT_DEPTH]: '%',
    [MachineAttribute.HEADER_WIDTH_DIMENSION]: 'm',
    [MachineAttribute.DIMENSION_HEIGHT]: 'cm',
    [MachineAttribute.DIMENSION_WIDTH]: 'cm',
    [MachineAttribute.DIMENSION_LENGTH]: 'cm',
    [MachineAttribute.WORKING_WIDTH]: 'm',
    [MachineAttribute.WEIGHT]: 'kg',
    [MachineAttribute.WEIGHT_GROSS]: 'kg',
    [MachineAttribute.CAPACITY]: 'L',
    [MachineAttribute.HOPPER_CAPACITY]: 'L',
    [MachineAttribute.HECTARES_WORKED]: 'ha',
};

export const getMachineUnit = (key: MachineAttribute, locale: TLocale) => {
    const value = units[key];
    if (!value) {
        return undefined;
    }
    if (typeof value === 'string') {
        return value;
    }
    return value[locale];
};
